import { render, staticRenderFns } from "./InformationRequestDialog.vue?vue&type=template&id=5fce6ee6&scoped=true&"
import script from "./InformationRequestDialog.vue?vue&type=script&lang=js&"
export * from "./InformationRequestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fce6ee6",
  null
  
)

export default component.exports